var _rect, _rect2, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLanguage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 32,
    height: 44,
    rx: 4,
    fill: "#A39090"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 9,
    width: 26,
    height: 38,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 35H37",
    stroke: "#A39090",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 41H37",
    stroke: "#A39090",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9916 13.6667C23.3916 13.6667 19.6666 17.4 19.6666 22C19.6666 26.6 23.3916 30.3333 27.9916 30.3333C32.6 30.3333 36.3333 26.6 36.3333 22C36.3333 17.4 32.6 13.6667 27.9916 13.6667ZM33.7666 18.6667H31.3083C31.0416 17.625 30.6583 16.625 30.1583 15.7C31.6916 16.225 32.9666 17.2917 33.7666 18.6667ZM28 15.3667C28.6916 16.3667 29.2333 17.475 29.5916 18.6667H26.4083C26.7666 17.475 27.3083 16.3667 28 15.3667ZM21.55 23.6667C21.4166 23.1333 21.3333 22.575 21.3333 22C21.3333 21.425 21.4166 20.8667 21.55 20.3333H24.3666C24.3 20.8833 24.25 21.4333 24.25 22C24.25 22.5667 24.3 23.1167 24.3666 23.6667H21.55ZM22.2333 25.3333H24.6916C24.9583 26.375 25.3416 27.375 25.8416 28.3C24.3083 27.775 23.0333 26.7167 22.2333 25.3333ZM24.6916 18.6667H22.2333C23.0333 17.2833 24.3083 16.225 25.8416 15.7C25.3416 16.625 24.9583 17.625 24.6916 18.6667ZM28 28.6333C27.3083 27.6333 26.7666 26.525 26.4083 25.3333H29.5916C29.2333 26.525 28.6916 27.6333 28 28.6333ZM29.95 23.6667H26.05C25.975 23.1167 25.9166 22.5667 25.9166 22C25.9166 21.4333 25.975 20.875 26.05 20.3333H29.95C30.025 20.875 30.0833 21.4333 30.0833 22C30.0833 22.5667 30.025 23.1167 29.95 23.6667ZM30.1583 28.3C30.6583 27.375 31.0416 26.375 31.3083 25.3333H33.7666C32.9666 26.7083 31.6916 27.775 30.1583 28.3ZM31.6333 23.6667C31.7 23.1167 31.75 22.5667 31.75 22C31.75 21.4333 31.7 20.8833 31.6333 20.3333H34.45C34.5833 20.8667 34.6666 21.425 34.6666 22C34.6666 22.575 34.5833 23.1333 34.45 23.6667H31.6333Z",
    fill: "#F26D6B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguage);
export default __webpack_public_path__ + "static/media/language.050b51db50f3071c1ce2b2e479328b16.svg";
export { ForwardRef as ReactComponent };